import { StrictMode, lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import AppFallback from './views/placeholders/app-fallback'

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// css from tailwind
import './index.css';

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'

import { AppContextProvider } from '@utils/contexts';

import './i18n';

// ** Sentry tracking
import * as Sentry from "@sentry/react"
import { Integrations } from "@sentry/tracing"

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: "https://4e622b9a9f464d8380a031bf9d99fb98@o413241.ingest.sentry.io/5937251",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<AppFallback />}>
      <StrictMode>
        <AppContextProvider>
          <LazyApp />
          <ToastContainer newestOnTop />
        </AppContextProvider>
      </StrictMode>
    </Suspense>
  </Provider>,
  document.getElementById('root')
);


